import { IChangeRouteAction } from './types';
import { showAlert } from '../../slices/alertSlice';
import { TThunkAction } from '../../types/redux/thunk';
import { ERoute } from '../../types/route';
// eslint-disable-next-line import/no-cycle
import { getArchivedChats } from '../archivedList';
import { getChats } from '../chatList/getChats';
import { EInternetStatus } from '../internetStatus';
import { getSpamChats } from '../spamList';
import { getStarredChats } from '../starredChatsList';
import { getUnreadChats } from '../unreadList';

export const changeRoute =
  ({ route, notClearCurrentOpenedChatId }: IChangeRouteAction): TThunkAction<void> =>
  (dispatch, getState) => {
    const state = getState();

    const { internetStatus } = state;
    if (internetStatus !== EInternetStatus.Online) {
      dispatch(showAlert({ message: 'Нет сети' }));

      return;
    }

    /**
     * При переходе в список сообщений запрашиваем v1/chats и переписываем chatList в активные чаты
     */
    if (route === ERoute.Messages) {
      dispatch(getChats({ timestamp: undefined, notClearCurrentOpenedChatId }));
    }

    /**
     * При переходе в список непрочитанных сообщений запрашиваем v1/chats/get-unread-chats-desktop/ без timestamp, чтобы всегда загружать с первой страницы.
     *  - переписываем chatList в чаты из архива
     *  - ставим активный роут "Архив"
     */
    if (route === ERoute.Unread) {
      dispatch(getUnreadChats({ timestamp: undefined, notClearCurrentOpenedChatId }));
    }

    /**
     * При переходе в спам
     *  - запрашиваем v1/get-spam-chats-desktop без timestamp, чтобы всегда загружать с первой страницы.
     *  - переписываем chatList в чаты из спама
     *  - ставим активный роут "Спам"
     */
    if (route === ERoute.Spam) {
      dispatch(getSpamChats({ timestampSpam: undefined }));
    }

    /**
     * При переходе в архив
     *  - запрашиваем v1/chats/get-archived-chats-desktop без timestamp, чтобы всегда загружать с первой страницы.
     *  - переписываем chatList в чаты из архива
     *  - ставим активный роут "Архив"
     */
    if (route === ERoute.Archive) {
      dispatch(getArchivedChats({ timestampArchive: undefined }));
    }
    /**
     * При переходе в важные чаты
     *  - запрашиваем v1/chats/get-starred-chats-desktop без timestamp, чтобы всегда загружать с первой страницы.
     *  - переписываем chatList в важные чаты
     *  - ставим активный роут "Важные"
     */
    if (route === ERoute.Starred) {
      dispatch(getStarredChats({ timestampStarred: undefined }));
    }
  };
